import * as graph from '@adc/sdk'
import { Person, OnlineAuctionSegmentBidRank } from '@adc/sdk/types'
// @ts-ignore no types
import dedent from 'dedent'

export const getInitials = (person: Person) => {
  return (
    (person?.first_name?.slice(0, 1) || '').toUpperCase() +
    (person?.last_name?.slice(0, 1) || '').toUpperCase()
  )
}

export const getRankAndOrdinal = (number: number) => {
  let b = number % 10
  return ~~((number % 100) / 10) === 1
    ? `${number}th`
    : b === 1
    ? `${number}st`
    : b === 2
    ? `${number}nd`
    : b === 3
    ? `${number}rd`
    : `${number}th`
}

export const acceptedOffer = (bidRank: OnlineAuctionSegmentBidRank) =>
  bidRank?.bid?.terms?.status &&
  [
    graph.enums.SealedBidStatus.SellerAccepted,
    graph.enums.SealedBidStatus.BuyerAccepted,
  ].includes(bidRank?.bid?.terms?.status)

export const NET_OFFER_AMOUNT_TOOLTIP = dedent(`
  The value of the offer after deducting any concessions requested by the buyer 
  and commissions to be paid by the seller. The net offer amount is not the net 
  proceeds that will be received by the seller at closing.
`)
export const isTied = (currentBidRank: OnlineAuctionSegmentBidRank) =>
  (currentBidRank.max_tied_rank ?? 0) >= 1
